export default __webpack_public_path__ + "static/media/traffic-full-web_big.8886afa4.jpg";